var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLandFinnland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#f5f5f5",
    cx: 18,
    cy: 18,
    r: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0069b3",
    d: "m18 33c-2.13 0-4.16-.44-6-1.25v-10.75h-8.7c-.2-.97-.3-1.97-.3-3s.1-2.03.3-3h8.7v-10.75c1.83-.8 3.87-1.25 6-1.25v12h14.7c0 .97.3 1.97.3 3 0 1.02-.1 2.03-.3 3h-14.7z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandFinnland);
export default __webpack_public_path__ + "static/media/land_finnland.bc11276c785fa4de61aad848d2c222bb.svg";
export { ForwardRef as ReactComponent };